module.exports = __webpack_public_path__ + "5bc44212da8f41e4529f12aabeb6f11d.MP3";